define([
	"lodash",
	"dojo/_base/declare",
	"csi/heading/RefContainer",
	"csi/xml"
], function(_, declare, RefContainer, xml) {

	const MAIN_PATH = "Child:Assignment/Child:__Members__";
	const SUBGROUP_PATH = "Child:SubGroups/Child:Assignment/Child:__Members__";

	return declare(RefContainer, {
		/**
		 * @override
		 * Add dependency paths for nodes
		 */
		addRendererDependencyPaths(h, paths) {
			paths.push(MAIN_PATH);
			paths.push(SUBGROUP_PATH);
		},

		/**
		 * @override
		 * Filtering not allowed since combining multiple paths
		 */
		getQuerySpec(ctx, h, spec) {
			return null;
		},

		/**
		 * @override
		 * Combine nodes from two paths to get all members
		 */
		getReferencedNodes(ctx, h) {
			const mainGroup = ctx.getNode();
			const mainMembers = ctx.cache.getPathNodes(mainGroup, MAIN_PATH);
			const subGroupMembers = ctx.cache.getPathNodes(mainGroup, SUBGROUP_PATH);
			const members = _.uniq(_.compact([...mainMembers, ...subGroupMembers]));
			return xml.sortNodes(members);
		}
	});
});